export default __webpack_public_path__ + "atomic/_patterns/03-organisms/content-item-list/_content-item-list.twig";